//TransInformationAction.js

var dispatcher = require("../dispatcher");

module.exports = {
    addTransporter:function(transport){
        dispatcher.dispatch({
            transport:transport,
            type:"transport:addTransporter"
        })
    },
    GoOtp:function(otp){
        dispatcher.dispatch({
            otp:otp,
            type:"transport:GoOtp"
        })
    },
    SubmitOTP:function(Verifiedotp){
        dispatcher.dispatch({
            Verifiedotp:Verifiedotp,
            type:"transport:SubmitOTP"
        })
    }
}





// WEBPACK FOOTER //
// ./src/actions/TransInformationAction.js